import { render, staticRenderFns } from "./VerticalImage.vue?vue&type=template&id=3140ae28&scoped=true&"
import script from "./VerticalImage.vue?vue&type=script&lang=js&"
export * from "./VerticalImage.vue?vue&type=script&lang=js&"
import style0 from "./VerticalImage.vue?vue&type=style&index=0&id=3140ae28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140ae28",
  null
  
)

export default component.exports